// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"4483":"css/admin-app.6961","6536":"css/app.6961"}[chunkId] + ".css";
};